import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const pointMarkerIcon = css`
  pointer-events: none;
`
export const pointMarker = css`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 5;
`
export const paper = css`
  z-index: 1;
  overflow: initial;
`
export const geolocationButton = {
  root: css`
    inset-block-start: ${spacing(-8)};
    position: absolute;
    inset-inline-end: 0;
    z-index: 1;
  `,
}
export const map = css`
  position: relative;
  flex: 1;
  margin-top: ${spacing(-3)};
`
export const backButton = css`
  margin: ${spacing(0, 0, 1, 1)};
  position: absolute;
  left: 0;
  bottom: 100%;
  z-index: 1;
`
export const subtitle = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  display: block;
`
export const titleIcon = css`
  width: ${spacing(1.75)};
  height: ${spacing(1.75)};
  border: 3px solid ${cssTheme.default.day.text};
  border-radius: 50%;
`
